// Height choices for the register form: grouped as Below average / Average / Above average, shown as "5 ft 6 in (167 cm)".
// The saved value stays in the old style (5'6") so filters, partner preferences and old profiles keep working.
export const inchesToValue = (total) => `${Math.floor(total / 12)}'${total % 12}"`;
export const inchesToCm = (total) => Math.round(total * 2.54);
export const inchesToLabel = (total) => `${Math.floor(total / 12)} ft ${total % 12} in (${inchesToCm(total)} cm)`;
export const heightGroup = (total) => (total < 61 ? 'Below average' : total < 64 ? 'Average' : 'Above average');

const MIN_INCHES = 55; // 4 ft 7 in
const MAX_INCHES = 84; // 7 ft 0 in

export const HEIGHT_OPTIONS = Array.from({ length: MAX_INCHES - MIN_INCHES + 1 }, (_, i) => {
    const total = MIN_INCHES + i;
    return { value: inchesToValue(total), label: inchesToLabel(total), group: heightGroup(total) };
});

// a typed height in cm (120 to 230) -> the saved value, or '' when it is not a sensible height
export const cmToValue = (cm) => {
    const n = Number(cm);
    if (!Number.isFinite(n) || n < 120 || n > 230) return '';
    return inchesToValue(Math.round(n / 2.54));
};

// "5'6\"" -> "5 ft 6 in (167 cm) · Average"
export const describeHeight = (value) => {
    const m = /^(\d+)'(\d+)"$/.exec(String(value || ''));
    if (!m) return '';
    const total = Number(m[1]) * 12 + Number(m[2]);
    return `${inchesToLabel(total)} · ${heightGroup(total)}`;
};

// ── weight: same style as height (Below average / Average / Above average, or type it in) ──
const MIN_KG = 40;
const MAX_KG = 120;
export const weightGroup = (kg) => (kg < 50 ? 'Below average' : kg < 70 ? 'Average' : 'Above average');
export const WEIGHT_OPTIONS = Array.from({ length: MAX_KG - MIN_KG + 1 }, (_, i) => {
    const kg = MIN_KG + i;
    return { value: `${kg} kg`, label: `${kg} kg`, group: weightGroup(kg) };
});
// a typed weight in kg (30 to 200) -> the saved value ("62 kg"), or '' when it is not sensible
export const kgToValue = (kg) => {
    const n = Math.round(Number(kg));
    return Number.isFinite(n) && n >= 30 && n <= 200 ? `${n} kg` : '';
};
export const describeWeight = (value) => {
    const n = parseInt(value, 10);
    return Number.isFinite(n) ? `${n} kg · ${weightGroup(n)}` : '';
};
